module.exports = __webpack_public_path__ + "static/media/galeryCurtains5.37df3647.jpg";